import { ReactComponent as CreatePencilIcon } from '../../../assets/icons/create-pencil.svg';
import { ReactComponent as ImageIcon } from '../../../assets/icons/image.svg';
import { ReactComponent as UserIcon } from '../../../assets/icons/user.svg';
import { ReactComponent as PreferencesIcon } from '../../../assets/icons/preferences.svg';
import { ReactComponent as EyeIcon } from '../../../assets/icons/eye.svg';
import { ClientUsersTable } from './client-users-table';
import { useNavigate } from 'react-router-dom';

export interface ClientCardProps {
  client: any;
  canEdit: boolean;
  canInvite: boolean;
  canCustomize: boolean;
  canPreview: boolean;
  showActionsColumn: boolean;
  onEdit: () => void;
  onInvite: () => void;
  onCustomize: () => void;
}

export const ClientCard = ({
  client,
  canEdit,
  canInvite,
  canCustomize,
  canPreview,
  showActionsColumn,
  onEdit,
  onInvite,
  onCustomize,
}: ClientCardProps) => {
  const navigate = useNavigate();

  const handlePreview = () => {
    navigate(`/reports-old?previewClientId=${client.ext_client_id}&previewClientName=${encodeURIComponent(client.title)}`);
  };

  return (
    <div className="flex flex-col bg-white rounded-2xl shadow-md p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
        <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-white border border-gray-400 rounded-xl overflow-hidden">
          {client.brand ? (
            <img
              src={client.brand}
              alt="Brand"
              className="object-contain w-12 h-12 sm:w-16 sm:h-16"
            />
          ) : (
            <ImageIcon className="w-5 h-5 sm:w-7 sm:h-7" />
          )}
        </div>
        <div className="flex-1 min-w-0 text-center sm:text-left">
          <div className="text-lg font-bold truncate mb-2">
            {client.title}
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full mt-4">
            {canEdit && (
              <button
                className="flex items-center justify-center gap-2 flex-1 px-4 py-2 rounded-xl bg-gray-200 text-black font-semibold text-sm shadow-sm hover:bg-gray-100 transition whitespace-nowrap"
                onClick={onEdit}
                type="button"
              >
                <CreatePencilIcon
                  className="w-4 h-4"
                  fill="black"
                />
                Edit
              </button>
            )}
            {canCustomize && (
              <button
                className="flex items-center justify-center gap-2 flex-1 px-4 py-2 rounded-xl bg-gray-200 text-black font-semibold text-sm shadow-sm hover:bg-gray-100 transition whitespace-nowrap"
                onClick={onCustomize}
                type="button"
              >
                <PreferencesIcon className="w-4 h-4" />
                Customize Dashboard
              </button>
            )}
            {canInvite && (
              <button
                className="flex items-center justify-center gap-2 flex-1 px-4 py-2 rounded-xl bg-gray-200 text-black font-semibold text-sm shadow-sm hover:bg-gray-100 transition whitespace-nowrap"
                onClick={onInvite}
                type="button"
              >
                <UserIcon className="w-4 h-4" />
                Invite Users
              </button>
            )}
            {canPreview && (
              <button
                className="flex items-center justify-center gap-2 flex-1 px-4 py-2 rounded-xl bg-gray-200 text-black font-semibold text-sm shadow-sm hover:bg-gray-100 transition whitespace-nowrap"
                onClick={handlePreview}
                type="button"
              >
                <EyeIcon className="w-4 h-4" />
                Preview
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="mt-6">
        <ClientUsersTable
          client={client}
          showActionsColumn={showActionsColumn}
        />
      </div>
    </div>
  );
};